<template>
  <div class ="h-list">
    <slot />
    <div class="fade-out"></div>
  </div>
</template>
<script>
/**
 * Used to show a long, horizontal list of items - in a compact manner.
 * Usually used for a row of many buttons, but you can put whatever you want in the default slot.
 *
 * Normal state: the contents will be restricted to one line, and there's a fade-out effect on the right to hide any overflowing content
 * On hover: the contents gets fully expanded to however many lines it needs
 *
 * Note: this component relies on your ability to hover, so it's not the best for mobile
 */
export default {
  name: 'HorizontalList'
}
</script>
<style lang="scss" scoped>
.h-list {
  position: relative;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  align-items: center;
}

.h-list .fade-out {
  position: absolute;
  right: 0;
  top: 0;
  width: 240px;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(to right, transparent 0%, #F5F7F7 60%);
}

.h-list:hover {
  white-space: normal;
  flex-wrap: wrap;
  max-height: 1000px; /* large enough to show all buttons */
  overflow: visible;
}

.h-list:hover .fade-out {
  display: none;
}
</style>
